import React from 'react';
interface DecorativeDiamondProps {
  className?: string;
  color?: 'rose' | 'pink' | 'coral' | 'gold';
}
export function DecorativeDiamond({
  className = '',
  color = 'gold'
}: DecorativeDiamondProps) {
  const colors = {
    rose: 'border-brand-rose',
    pink: 'border-brand-pink',
    coral: 'border-brand-coral',
    gold: 'border-brand-gold'
  };
  return <div className={`absolute w-16 h-16 border-2 ${colors[color]} opacity-20 transform rotate-45 ${className}`} data-id="element-153" />;
}